
    import '/home/ec2-user/Youlify-Design/components/flex/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["flex-demo-basic","flex-demo-align","flex-demo-gap","flex-demo-wrap","flex-demo-combination","flex-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/flex/index.zh-CN.md?type=demo')
};